import React from 'react';
import { useNavigate } from 'react-router-dom';
import img from '../images/onboarding-dashboard3.png';
import img2 from '../images/slider3.png';

export default function Splash3() {
  const navigate = useNavigate();

  const handleLogin = () => {
    navigate('/login');
  };

  const handleSignup = () => {
    navigate('/signup');
  };

  return (
    <div className='splashnew-container1'>
      <div className='onboarding-dashboard-img'>
        <img src={img} alt="" />
      </div>
      <div className='onboarding-bg'>
        <div className='onboarding-content'>
          <h3>Set key alerts to stay on top of your day</h3>
          <div className='onboarding-img'>
            <img src={img2} alt="" />
          </div>
          <div className='onboarding-btns'>
            <div className='onboarding-btn3'>
              <button onClick={handleLogin}>Login</button>
            </div>                 
          </div>
          <p>
            Don’t have an account?
            <span onClick={handleSignup} style={{ cursor: 'pointer', marginLeft: '5px' }}>
              Sign Up
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}
